interface AIEngineBadgeProps {
  engine: string | null | undefined;
  className?: string;
}

export default function AIEngineBadge({
  engine,
  className = "",
}: AIEngineBadgeProps) {
  if (engine === "inha_jsd") {
    return (
      <span
        className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 ${className}`}
      >
        인하대 JSD
      </span>
    );
  }
  if (engine === "mock") {
    return (
      <span
        className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600 ${className}`}
      >
        Mock
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-500 ${className}`}
    >
      알 수 없음
    </span>
  );
}
